module.exports = __webpack_public_path__ + "static/media/icon-fully-customizable.210d519a.svg";